import { connect } from "react-redux";
import { nextImage, previousImage, showMessages } from "../actions";
import { Dialog, DialogProps } from "../components/Dialog";
import { AnnotationsPartialState } from "../reducers/dtos";
import { getCurrentImage, getIsAnnotationsPopupOpened } from "../selectors";

interface OwnProps {
    close: F<void>;
}

const mapStateToProps = (state: AnnotationsPartialState, props: OwnProps): Partial<DialogProps> => ({
    isOpened: getIsAnnotationsPopupOpened(state),
    close: props.close,
    image: getCurrentImage(state),
});

const mapDispatchToProps: Partial<DialogProps> = {
    showMessages,
    previousImage,
    nextImage,
};

export const DialogContainer = connect(mapStateToProps, mapDispatchToProps)(Dialog);
